export default class ScreenUtilities {
  static get_screen_width() {
    return window.innerWidth
  }
}